export default __webpack_public_path__ + "static/media/background.ea996e73.png";